// extracted by mini-css-extract-plugin
export var labelWrapper = "Label-module--labelWrapper--eb2fe";
export var required = "Label-module--required--89ef3";